import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

interface NavbarProps {
  onOpenConsultation: () => void;
}

const Navbar = ({ onOpenConsultation }: NavbarProps) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Dla kogo", href: "#dla-kogo" },
    { label: "Co dostajesz", href: "#co-dostajesz" },
    { label: "Jak to działa", href: "#jak-to-dziala" },
    { label: "Opinie", href: "#opinie" },
    { label: "Pakiety", href: "#pakiety" },
    { label: "FAQ", href: "#faq" },
  ];

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white border-b border-gray-100" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 lg:h-18">
          <h1 className="contents">
            <a href="/" className="flex items-center cursor-pointer" title="Strony internetowe dla firm usługowych">
              <img
                src="https://public.readdy.ai/ai/img_res/57b8b140-7aaa-4dba-81ff-f2e4a216eacc.png"
                alt="Strony Internetowe dla Firm Usługowych — projektowanie stron www"
                title="Strony www dla lokalnych firm usługowych"
                className="h-8 lg:h-9 w-auto object-contain"
              />
            </a>
          </h1>

          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? "text-gray-600 hover:text-[#0F2557]"
                    : "text-white/80 hover:text-white"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <button
              onClick={onOpenConsultation}
              className="whitespace-nowrap px-5 py-2.5 rounded-md text-sm font-semibold bg-[#0F2557] text-white hover:bg-[#1B3D7A] transition-colors cursor-pointer"
            >
              Umów konsultację
            </button>
          </div>

          <button
            className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              scrolled ? "text-gray-800" : "text-white"
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <i className={`ri-${menuOpen ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="text-sm font-medium text-gray-700 hover:text-[#0F2557] cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={() => {
                setMenuOpen(false);
                onOpenConsultation();
              }}
              className="whitespace-nowrap px-5 py-2.5 rounded-md text-sm font-semibold bg-[#0F2557] text-white hover:bg-[#1B3D7A] transition-colors cursor-pointer w-full"
            >
              Umów bezpłatną konsultację
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
